<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="houseId" label="房源名称">
                        <form-lookup
                            v-model="lookupOptions.roomId"
                            :options.sync="lookupOptions.roomId"
                            placeholder="请选择房号"
                            title="选择房间"
                            textSymbol="title"
                            valueSymbol="id"
                            :modalHeight="600"
                            :modalWidth="900"
                            disabled
                            viewonly
                        >
                            <select-room :allowCheckParent="false" />
                        </form-lookup>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="账期" prop="period">
                        <Select
                            v-model="info.period"
                            transfer
                            placeholder
                            disabled
                        >
                            <Option
                                v-for="item in periodList"
                                :value="item.period"
                                :key="item.period"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="cusUser" label="客户姓名">
                        <Input
                            v-model="info.cusUser"
                            placeholder
                            disabled
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="cusMobile" label="客户手机号">
                        <Input
                            v-model="info.cusMobile"
                            placeholder
                            disabled
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="费用类型" prop="feeType">
                        <Select
                            v-model="info.feeType"
                            transfer
                            placeholder
                            disabled
                        >
                            <Option
                                v-for="item in dict.feeType.toList()"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="planDate" label="应付款日">
                        <DatePicker
                            v-model="info.planDate"
                            style="width: 100%"
                            type="date"
                            placeholder
                            disabled
                        >
                        </DatePicker>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="planAmount" label="应付金额">
                        <input-number
                            v-model="info.planAmount"
                            placeholder
                            disabled
                        >
                            <span slot="append">元</span>
                        </input-number>
                        <span class="res-amount-text">
                            {{ resAmountText }}
                        </span>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="realDate" label="已付款时间">
                        <DatePicker
                            v-model="info.realDate"
                            style="width: 100%"
                            type="datetime"
                            placeholder
                            transfer
                        >
                        </DatePicker>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="realAmount" label="已付金额">
                        <input-number v-model="info.realAmount" placeholder>
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="交易方式" prop="payType">
                        <Select
                            v-model="info.payType"
                            transfer
                            placeholder="请选择交易方式"
                        >
                            <Option
                                v-for="item in dict.payType.toList()"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="上传图片" prop="attachments">
                        <preview-upload
                            v-model="info.attachments"
                            multiple
                            :format="imgSuffix"
                            :maxNumber="10"
                        ></preview-upload>
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            :rows="4"
                            placeholder="0/1000"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <!-- 弹出框-提示 -->
        <alter :text="modalMsg" v-model="alterShow" @closeAlter="closeAlter" />
    </div>
</template>
<script>
import Dict from '_u/dict'
import config from '@/config'
import { deepCopy, ymd, ymdL } from '_u/helper'
import { getResAmountText } from '@/views/common/u-contract'
import { multiply } from '@/views/common/u-contract'

import SelectRoom from '_vc/select-room'
import Alter from '_v/components/alter'
import PreviewUpload from '_c/preview-upload'

import { billView, billPayment, billPeriods } from '@/api/bill'
import { assetsHouseView } from '@/api/assets'

export default {
    name: 'BillPaymentDfForm',

    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        depositOffset: {
            type: [String, Number],
            default: '',
        },
        offsetAmount: {
            type: [String, Number],
            default: '',
        },
    },

    components: { SelectRoom, Alter, PreviewUpload },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: '', // 账单编号
                billStatus: this.billStatus, // 账单状态
                houseId: '', // 房间编号
                period: '', // 账单期数
                startDate: '', // 开始日期
                endDate: '', // 结束日期
                cusId: '', // 租客编号
                cusUser: '', // 租客名称
                cusMobile: '', // 租客电话
                planDate: '', // 应付款日
                feeType: '', // 费用类型
                planAmount: '', // 待收/待付金额
                realDate: new Date(), // 实际收款/付款日期
                realAmount: '', // 实际收款/付款金额
                payType: '', // 支付方式
                leftAmount: '', // 剩余金额
                handleType: '', // 处理方式
                leftPayDate: '', // 剩余金额应付款日
                depositReceiptStatus: 0, // 已收定金收据状态
                attachments: '', // 附件
                remark: '',
                ver: '',
            },
            periodList: [], // 账期列表
            lookupOptions: {
                roomId: [],
            },
            imgSuffix: config.upload.imgSuffix,
            dict: {
                feeType: Dict.NULL,
                payType: Dict.NULL,
                handleType: Dict.NULL,
            },
            alterShow: false, // 是否显示弹出框
            modalMsg: '', // 提示框内容
        }
    },
    computed: {
        ruleValidate() {
            return {
                realDate: [{ required: true, message: '已付款时间必填' }],
                realAmount: [{ required: true, message: '已付金额必填' }],
                payType: [{ required: true, message: '交易方式必填' }],
            }
        },
        // 剩余金额
        lastAmount() {
            return this.info.planAmount - this.info.realAmount
        },
        resAmountText() {
            return getResAmountText(
                {
                    depositOffset: this.depositOffset,
                    offsetAmount: this.offsetAmount,
                },
                false
            )
        },
    },
    methods: {
        fetch() {
            return billView(this.id)
        },

        payment($info) {
            $info
                .validate()
                .then(() => {
                    var formData = deepCopy(this.info)
                    formData.realAmount = multiply(formData.realAmount)
                    formData.planAmount = multiply(formData.planAmount)
                    formData.planDate = ymd(formData.planDate)
                    formData.realDate = ymdL(formData.realDate)
                    formData.startDate = ymd(formData.startDate)
                    formData.endDate = ymd(formData.endDate)
                    formData.leftPayDate = ymd(formData.leftPayDate)
                    return billPayment(formData)
                })
                .then((res) => {
                    this.$modal.close()
                    this.$Message.success('付款成功')
                })
        },

        closeAlter() {
            this.alterShow = true
            this.payment(this.$refs.info)
        },
    },

    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        var btns = [{ type: 'default', text: '取消', name: 'cancel' }]

        if (this.$can('update')) {
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                this.fetch(),
                Dict.get(['fee_type', 'pay_type', 'handle_type']),
            ])
                .then((args) => {
                    var [view, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data.entity
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity
                        viewData.planAmount /= 100
                        viewData.realAmount = viewData.planAmount
                        viewData.handleType = '1'
                        viewData.payType = ''
                        Object.keys(this.info).forEach((name) => {
                            if (
                                viewData[name] !== null &&
                                viewData[name] !== ''
                            )
                                this.info[name] = viewData[name]
                        })

                        if (this.id) {
                            const info = this.info
                            if (info.period) {
                                this.periodList.push({
                                    period: info.period,
                                    text: `第${info.period}期(${info.startDate} 至 ${info.endDate})`,
                                    startDate: info.startDate,
                                    endDate: info.endDate,
                                })
                            }
                        }
                        return assetsHouseView(this.info.houseId)
                    }
                    return Promise.resolve()
                })
                .then((res) => {
                    if (res) {
                        const house = res.data.entity
                        this.lookupOptions.roomId.push({
                            id: this.info.houseId,
                            title: `${house.parkName}${house.floorName}${house.houseNum}`,
                        })
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            if (
                this.info.feeType === '5' &&
                this.info.depositReceiptStatus === 1
            ) {
                this.modalMsg =
                    '定金退还后已开收据自动作废，可前往“已收账单”中筛选收据状态为“作废”'
                this.alterShow = true
            } else {
                this.payment($info)
            }
        })
    },
}
</script>
<style lang="less" scoped>
.res-amount-text {
    color: red;
    position: absolute;
    top: 27px;
    left: 0px;
}
</style>
